import getRole from "./RoleService";

const uri = `${import.meta.env.VITE_BASE_URL}/api/range-date-event`;

const GetAllWeekConfig = async (date, isCurrentUsed) => {
  try {
    const role = await getRole();
    if (role) {
      const { token } = role;

      const response = await fetch(
        `${uri}/get-all?date=${date}&isCurrentUsed=${isCurrentUsed}`,
        {
          method: "get",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Client Error" };
  }
};

const AddWeekConfig = async (startDate, endDate, name, amountDate) => {
  try {
    const role = await getRole();
    if (role) {
      const { token } = role;
      const isCurrentUsed = 1;
      const formData = new FormData();
      formData.append("startDate", startDate);
      formData.append("endDate", endDate || "");
      formData.append("name", name || "");
      formData.append("amountDate", amountDate || "");
      formData.append("isCurrentUsed", isCurrentUsed || "");
      const response = await fetch(`${uri}`, {
        method: "post",
        headers: {
          authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Client Error" };
  }
};

const UpdateWeekConfig = async (
  id,
  startDate,
  endDate,
  name,
  amountDate,
  isCurrentUsed
) => {
  try {
    const role = await getRole();
    if (role) {
      const { token } = role;
      const formData = new FormData();
      formData.append("id", id);
      formData.append("startDate", startDate);
      formData.append("endDate", endDate || "");
      formData.append("name", name || "");
      formData.append("amountDate", amountDate || "");
      formData.append("isCurrentUsed", isCurrentUsed || "");
      const response = await fetch(`${uri}/update`, {
        method: "post",
        headers: {
          authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Client Error" };
  }
};

const GetWeekIdByMonth = async () => {
  try {
    const role = await getRole();
    if (role) {
      const { token } = role;
      const name = "This month";
      const response = await fetch(`${uri}/get-all?name=${name}`, {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Client Error" };
  }
};
export { AddWeekConfig, GetAllWeekConfig, UpdateWeekConfig, GetWeekIdByMonth };
